import { TableButton } from '@ipfabric/ui-components/TableButton/TableButton';
import {
  createBooleanColumn,
  createDateTimeColumn,
  createTextColumn,
} from '@ipfabric/utils';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import {
  formatRuleLabelLines,
  formatRuleTargetLines,
  rulesTableTextFilter,
} from './ruleTableDisplay';
import type { RulesTableRow } from './rulesTableRow';

type RulesTableColumnHandlers = {
  onDelete: (id: string, description: string) => void;
  onEdit: (rule: RulesTableRow) => void;
};

export const createRulesTableColumns = ({
  onDelete,
  onEdit,
}: RulesTableColumnHandlers) => [
  createTextColumn<RulesTableRow>({
    key: 'id',
    title: 'ID',
    hidden: true,
  }),
  {
    ...createFrontendOnlyColumn<RulesTableRow>({
      key: 'target',
      title: 'Target',
      render: (row) => (
        <div className='flex flex-col gap-3xs text-sm'>
          {formatRuleTargetLines(row.filter).map((line) => (
            <span key={line}>{line}</span>
          ))}
        </div>
      ),
    }),
    filter: rulesTableTextFilter,
  },
  {
    ...createFrontendOnlyColumn<RulesTableRow>({
      key: 'labelsSummary',
      title: 'Labels',
      render: (row) => (
        <div className='flex flex-col gap-3xs text-sm'>
          {formatRuleLabelLines(row.labels).map((line) => (
            <span key={line}>{line}</span>
          ))}
        </div>
      ),
    }),
    filter: rulesTableTextFilter,
  },
  createBooleanColumn<RulesTableRow>({
    key: 'inherit',
    title: 'Inherit',
  }),
  createTextColumn<RulesTableRow>({
    key: 'description',
    title: 'Description',
  }),
  createDateTimeColumn<RulesTableRow>({
    key: 'changedAt',
    title: 'Last change',
    format: 'dateFormat',
  }),
  createTextColumn<RulesTableRow>({
    key: 'changedBy',
    title: 'Changed by',
  }),
  createFrontendOnlyColumn<RulesTableRow>({
    key: 'actions',
    title: 'Actions',
    disabledSort: true,
    webDependencies: ['id', 'description'],
    render: (row) => (
      <div className='flex flex-row items-center gap-xs'>
        <TableButton
          dataTestId={`rules-list-edit-${row.id}`}
          variant='plain'
          icon='fa-pen'
          size='default'
          onClick={() => onEdit(row)}
          type='button'
        />
        <TableButton
          dataTestId={`rules-list-remove-${row.id}`}
          variant='plain'
          accent='negative'
          icon='fa-trash-can'
          size='default'
          onClick={() => onDelete(row.id, row.description)}
          type='button'
        />
      </div>
    ),
  }),
];
